// Platform constants
export const PLATFORMS = ['All', 'iOS', 'macOS', 'watchOS', 'tvOS', 'iPadOS', 'visionOS'];

// Section names
export const SECTION_NAMES = {
  FRAMEWORKS_APIS: 'Frameworks & APIs',
  DEVICE_CAPABILITY: 'Device capability',
  USER_FACING_FEATURES: 'User facing features',
  TOOLS_LANGUAGES: 'Tools & Languages',
  OS: 'OS'
};

// All available categories (extracted from data analysis)
export const CATEGORIES = [
  'System',
  'Health', 
  'AI/ML',
  'Media',
  'AR/Spatial',
  'Input',
  'Widgets',
  'Communication',
  'Authentication',
  'Drawing'
];